import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from '../reducers/vehicle.reducer';
import { AppDispatch } from '../store';
import { RootState, VehicleState } from '../types/store.types';

export const useVehicleStore = () => {
  const vehicleStore = useSelector<RootState, VehicleState>((state) => state.vehicle);
  const dispatch = useDispatch<AppDispatch>();
  const {
    updateFilter,
    updateVehicleData,
    updateRentalData,
    getVehicles,
    getVehicleById,
    createVehicle,
    getRentals,
    createRental,
    getBranchs,
    getCompanys,
    getListOfItems,
    deleteRental,
    getResourceDetails,
    vehicleStatusUpdate,
    unitList,
  } = vehicleActions;

  return {
    getRentals,
    getVehicles,
    getVehicleById,
    createVehicle,
    updateFilter,
    dispatch,
    vehicleStore,
    updateVehicleData,
    updateRentalData,
    createRental,
    getBranchs,
    getCompanys,
    getListOfItems,
    deleteRental,
    getResourceDetails,
    vehicleStatusUpdate,
    unitList,
  };
};
